import styled, { css } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div`
    padding: ${(props) => `${props.theme.spacing.medium} ${props.theme.spacing.medium} 0`};
    display: flex;
    align-items: center;
`;

export const HalfWidthContainer = styled.div`
    width: 50%;
`;

export const PaymentMethodContainer = styled(HalfWidthContainer)<{
    shouldStopAIPcontainerWidth?: boolean;
    shouldShowLoadingState?: boolean;
    isQuickCheckout?: boolean;
}>`
    display: flex;
    flex-direction: column;

    ${({ isQuickCheckout, shouldStopAIPcontainerWidth }) =>
        isQuickCheckout &&
        css`
            width: ${shouldStopAIPcontainerWidth ? "50%" : "40%"};
            min-width: 0;
        `}

    ${({ shouldShowLoadingState = false }: { shouldShowLoadingState?: boolean }) =>
        shouldShowLoadingState &&
        css`
            position: relative;
            opacity: 0.5;
            pointer-events: none;
        `}
`;

export const PaymentMethodPayButtonContainer = styled(HalfWidthContainer)<{
    shouldStopAIPcontainerWidth?: boolean;
    isQuickCheckout?: boolean;
}>`
    margin-left: ${(props) => props.theme.spacing.medium};
    width: ${({ isQuickCheckout, shouldStopAIPcontainerWidth }) =>
        isQuickCheckout && !shouldStopAIPcontainerWidth ? "60%" : "50%"};
`;

export const Flex = styled.div`
    display: flex;
    align-items: center;
`;

export const DisplayNameContainer = styled.div`
    display: flex;
`;

export const PrimaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const DynamicPromoSubText = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledText = styled(Text)<{ isQuickCheckout?: boolean }>(({ theme, isQuickCheckout = false }) => ({
    margin: `0 ${theme.spacing.xxxSmall} 0 ${theme.spacing.xxSmall}`,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    ...(isQuickCheckout && {
        maxWidth: "fit-content",
    }),
}));

export const IconWrapper = styled.span`
    margin: ${(props) => `0 ${props.theme.spacing.xxxSmall} ${props.theme.spacing.xxSmall}`};
`;

export const KfsDisclaimerContainer = styled.div`
    margin: ${(props) => props.theme.spacing.x9} ${(props) => props.theme.spacing.medium} 0
        ${(props) => props.theme.spacing.medium};
    padding: ${(props) => props.theme.spacing.x5} 0 0 0;
    border-top: 1px solid ${(props) => props.theme.colors[props.theme.colorMode].border_Tertiary};
    text-align: center;
`;

export const KfsLink = styled.span`
    text-decoration: underline;
    cursor: pointer;
`;

const iconHeight = 14;
const iconWidth = 21;

export const PaymentIconV2 = styled.div`
    height: ${iconHeight}px;
    width: ${iconWidth}px;
    border-radius: ${(props) => props.theme.spacing.xxSmall};
    border: 1px solid ${(props) => props.theme.colors[props.theme.colorMode].border_Tertiary};
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.colors[props.theme.colorMode].overlay_Heading_Text};
    img {
        max-height: ${(props) => props.theme.spacing.small};
        width: auto;
        max-width: 100%;
    }
`;
